export enum ComparisonOperator {
  EQUALS = '$eq',
  GREATER = '$gt',
  GREATER_OR_EQUAL = '$gte',
  CONTAINS = '$in',
  LOWER = '$lt',
  LOWER_OR_EQUAL = '$lte',
  NOT_EQUAL = '$ne',
  NOT_CONTAINS = '$nin',
  LIKE = '$like',
  REGEXP = '$re',
  FULLTEXT = '$fulltext',
  ILIKE = '$ilike'
}

export enum LogicalOperator {
  AND = '$and',
  NOT = '$not',
  OR = '$or',
}

export enum Direction {
  ASC = 'ASC',
  DESC = 'DESC',
}

export interface IFilterItem {
  name: string;
  value: string;
  comparison: ComparisonOperator;
  logical_operator?: string;
}

export interface IFilterQuery {
  sortField?: string;
  sortOrder?: Direction;
  filter?: Array<IFilterItem>;
  limit: number;
  page: number;
}

export interface IPageable {
  count: number;
  total: number;
  pageCount: number;
  page: number;
}

export interface IPageableData<R> extends IPageable {
  data: Array<R>;
}
export interface IResponse<R> {
  data: null | R | Array<R>;
  // error: null | IError;
}

export interface IPageableResponseData<R> extends IPageable, IResponse<R> {}

export interface IError {
  code: null | number;
  field?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  params?: any;
  message: null | string;
}

export interface ISetOffice {
  officeId: string;
}

export interface ILocaleValue {
  [id: string]: string;
}

export enum Locale {
  RU = 'ru',
  EN = 'en',
  KG = 'kg',
}

export interface IFile {
  name: string;
  size: number;
  type: string;
  extension: string;
  base64: string;
};

export enum IDisplayType {
  ONE_X = '1x',
  TWO_X = '2x',
  THREE_X = '3x'
}

export enum EnableDisableStatus {
  Enabled = 'Enabled',
  Disabled = 'Disabled'
}

export interface IFileModel {
  fileKey: string,
  fileName: string,
  cdnUrl: string,
}

export const getEnableDisableStatusText = (status: EnableDisableStatus) => {
  switch (status) {
    case EnableDisableStatus.Disabled: return 'Disabled';
    case EnableDisableStatus.Enabled: return 'Enabled';
  }
}

export const getEnableDisableStatusColor = (status: EnableDisableStatus) => {
  switch (status) {
    case EnableDisableStatus.Disabled: return 'blue-grey-10';
    case EnableDisableStatus.Enabled: return 'green';
  }
}

export enum PaymentStatus {
  WAITING = 'waiting',
  PAID = 'paid',
  RETURNS = 'returns'
}

export const getPaymentStatusColor = (status: PaymentStatus) => {
  switch (status) {
    case PaymentStatus.PAID: return 'green';
    case PaymentStatus.WAITING: return 'light-blue-7';
    case PaymentStatus.RETURNS: return 'red-7';
  }
}

export const getPaymentStatusText = (status: PaymentStatus) => {
  switch (status) {
    case PaymentStatus.PAID: return 'paidStatus';
    case PaymentStatus.WAITING: return 'waitingStatus';
    case PaymentStatus.RETURNS: return 'returns';
  }
}

export interface BasicType {
  id: string;
  name: string | ILocaleValue;
}


export enum FileType {
  VIDEO = 'VIDEO',
  FILE = 'FILE',
  PDFMANUAL = "PDFMANUAL",
}

export enum MimeType {
  PDF = "application/pdf",
  OCTET_STREAM = "application/octet-stream",
  PNG = "image/png",
  DOCX = "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  MD = "text/markdown",
  JPG = "image/jpeg",
  GIF = "image/gif"
}

export enum FileStatus {
  UPLOADED_LOCAL = 'UPLOADED_LOCAL',
  UPLOADING_TO_AWS = 'UPLOADING_TO_AWS',
  UPLOADED_TO_AWS = 'UPLOADED_TO_AWS',
  FILE_NOT_EXIST = 'FILE_NOT_EXIST',
  CONVERTING_TO_HLS = 'CONVERTING_TO_HLS',
  CONVERTED_TO_HLS = 'CONVERTED_TO_HLS',
}

export const Weekday: ILocaleValue[] = [
  {
    kg: 'Дүйшөмбү',
    ru: 'Понедельник',
    default: 'Понедельник'
  },
  {
    kg: 'Шейшемби',
    ru: 'Вторник',
    default: 'Вторник'
  },
  {
    kg: 'Шаршемби',
    ru: 'Среда',
    default: 'Среда'
  },
  {
    kg: 'Бейшемби',
    ru: 'Четверг',
    default: 'Четверг'
  },  {
    kg: 'Жума',
    ru: 'Пятница',
    default: 'Пятница'
  },
  {
    kg: 'Ишемби',
    ru: 'Суббота',
    default: 'Суббота'
  },
  {
    kg: 'Жекшемби',
    ru: 'Воскресенье',
    default: 'Воскресенье'
  }
]

export interface IJsonb {
  [id: string]: string;
}

export enum TelegramManagement{
  TELEGRAMuSER='1eedc4d3-763b-6d60-bd16-3cc986d61970'
}
export const showMore:{id:string, name:string}={
  name:'Показать еще',
  id:'more'
}
export const showMoreLocale:{id:string, name:ILocaleValue}={
  name:{
    ru:'Показать еще',
    en:'Show more',
    default:'Show more',
  },
  id:'more',
  
}

export interface basePageData{
  page:number,
  currentPage:number,
  pageCount:number
}
export const baseData:basePageData={
  page:1,
  currentPage:1,
  pageCount:1
}